export const getContentDispositionHeader = headers => (headers && (headers['content-disposition'] || headers['Content-Disposition'])) || '';

export const parseFilenameStarRFC5987 = contentDisposition => {
  const m = /filename\*\s*=\s*(?:[A-Za-z0-9_-]+''\s*)?([^;\n]+)/i.exec(contentDisposition);
  if (!m || !m[1]) return null;
  const raw = m[1].trim().replace(/^"|"$/g, '');
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
};

export const parseQuotedFilename = contentDisposition => {
  const m = /filename\s*=\s*"?([^";]+)"?/i.exec(contentDisposition);
  return m && m[1] ? m[1].trim().replace(/^"|"$/g, '') : null;
};

export const getFilenameFromContentDisposition = headers => {
  const cd = getContentDispositionHeader(headers);
  if (!cd) return null;
  return parseFilenameStarRFC5987(cd) || parseQuotedFilename(cd) || null;
};
